import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/CareerFairGame/scenes/GameIntro';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(PhaserDemo)'
interface PhaserCareerFairGameProps {
    onComplete: () => void;
}

interface PhaserCareerFairGameState {
}

const templateConfig: GameConfig = {
    title: "Career Fair Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 400 }
        }
    },
    backgroundColor: "#000000",
    "render.pixelArt": true // 'Anti-Aliasing' when off
};

class PhaserCareerFairGame extends React.Component<PhaserCareerFairGameProps, PhaserCareerFairGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserCareerFairGameProps) {
        super(props);
        bindAllOfThis(this, PhaserCareerFairGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={templateConfig} onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserCareerFairGame;



// WEBPACK FOOTER //
// ./src/games/CareerFairGame/Main.tsx